<template>
  <span>
    <svg
      width="282"
      height="296"
      viewBox="0 0 282 296"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M188.75 290.285C189.23 289.153 189.477 287.936 189.477 286.706L189.467 82.6416H272.705C275.17 82.6416 277.534 81.6614 279.278 79.9166C281.021 78.1718 282 75.8054 282 73.3379V9.30362C282 6.83614 281.021 4.46974 279.278 2.72497C277.534 0.980207 275.17 0 272.705 0H9.29496C6.82978 0 4.46558 0.980207 2.72243 2.72497C0.979289 4.46974 0 6.83614 0 9.30362V73.3379C0 75.8054 0.979289 78.1718 2.72243 79.9166C4.46558 81.6614 6.82978 82.6416 9.29496 82.6416H92.5136V286.706C92.5149 287.928 92.7566 289.138 93.2249 290.266C93.6932 291.394 94.379 292.419 95.243 293.282C96.1071 294.145 97.1325 294.829 98.2607 295.296C99.3889 295.762 100.598 296.001 101.818 296H180.102C181.323 296.003 182.532 295.766 183.661 295.301C184.79 294.837 185.817 294.154 186.682 293.292C187.567 292.439 188.27 291.416 188.75 290.285Z"
        fill="#00FFE0"
      />
    </svg>
  </span>
</template>
<script setup lang="ts"></script>
<style scoped lang="postcss">
span {
  display: inline-block;
  > svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
